export default __webpack_public_path__ + "static/iot-232f98fc6b5a6ac3da91560b29316a9b.svg";